const CONFIGURATION_PAGE_TEXT = {
  HEADER: 'Configuration',
};

export default CONFIGURATION_PAGE_TEXT;
